import Cookies from 'universal-cookie';

const cookies = new Cookies(); // используем библиотеку и создаем куки для быстрого обращения

/** проверка, есть ли сейчас куки, которое хранит в себе данные об авторизации пользователя */
export const checkAuthCookie = (): boolean => {
  return !!(cookies.get('accessToken'));
};
